import React, { useEffect, useRef } from 'react';

const YouTubePlayer = ({ video_id }) => {
  const playerRef = useRef(null);

  useEffect(() => {
    const createPlayer = () => {
      if (!window.YT || !window.YT.Player) return;
      playerRef.current = new window.YT.Player('youtube-player-container', {
        videoId: video_id,
        playerVars: {
          controls: 1,
          autoplay: 0, // Better UX on mobile: do not auto-blast audio
          rel: 0,
        },
        events: {
          onReady: () => {},
          onStateChange: () => {},
        },
      });
    };

    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = () => {
        createPlayer();
      };
    } else {
      createPlayer();
    }

    return () => {
      if (playerRef.current && typeof playerRef.current.destroy === 'function') {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [video_id]);

  return (
    <div className="youtube-responsive-wrapper my-4">
      <div id="youtube-player-container" className="youtube-responsive-iframe"></div>
    </div>
  );
};

export default YouTubePlayer;
